import { useContext, useEffect } from 'react';

import {
  LoadingImg,
  LoadingText,
  LoadMore,
} from '@pages/Products/components/ListProducts/ListProducts.styles';
import Rolling from '@assets/gif/rolling.gif';
import { useInView } from 'react-intersection-observer';
import { ListProductsLoading } from '@pages/Products/components/ListProducts/loading/ListProducts.loading';
import { IManufacturer } from '@models/Manufacturer.model';
import { manualAddSelectManufacturer } from '@services/mixpanel/trackers/ManualAdd';
import { NavigationContext } from '@layout/navigation/navigation';
import { Container, Image } from '../../../tables.styles';

import {
  FindButton,
  ColumnDiv,
  ProductDiv,
  Td,
  ProductHeader,
  ScrollDiv,
  TextMatches,
} from './ListManufacturersWithMatch.styles';

interface ListProductsProps {
  data?: IManufacturer[];
  isLoading: boolean;
  loadMore: () => void;
  updateDataSelected: (productRequest: IManufacturer) => void;
  hasMore?: boolean;
  handleClick: () => void;
}

const ListManufacturersWithMatch = ({
  data,
  isLoading,
  hasMore,
  loadMore,
  updateDataSelected,
  handleClick,
}: ListProductsProps) => {
  const { ref, inView } = useInView();
  useEffect(() => {
    if (inView && hasMore) loadMore();
  }, [inView, hasMore]);

  const { studioName } = useContext(NavigationContext);

  if (isLoading) {
    return <ListProductsLoading />;
  }
  if (!data) {
    return <div />;
  }
  return (
    <Container>
      <TextMatches>{`${data.length} Results`}</TextMatches>
      <ScrollDiv>
        {data.map(item => (
          <ProductDiv key={JSON.stringify(item)}>
            <Td width={40}>
              {item.imageUrl ? <Image src={item.imageUrl} alt="" /> : <div />}
              <ColumnDiv className="header">{item.name}</ColumnDiv>
            </Td>
            <Td width={20}>
              <ColumnDiv>
                <ProductHeader>Products</ProductHeader>

                {item.productsCount}
              </ColumnDiv>
            </Td>

            <Td width={20} />
            <Td width={20} />
            <Td width={20} />
            <FindButton
              onClick={() => {
                updateDataSelected(item);
                handleClick();
                manualAddSelectManufacturer(studioName, item.id, item.name);
              }}
            >
              Match
            </FindButton>
          </ProductDiv>
        ))}
        <LoadMore ref={ref}>
          {hasMore ? (
            <LoadMore>
              <LoadingText>Loading more</LoadingText>
              <LoadingImg src={Rolling} alt="loading" />
            </LoadMore>
          ) : (
            <div />
          )}
        </LoadMore>
      </ScrollDiv>
    </Container>
  );
};

export { ListManufacturersWithMatch };
